'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import Select from 'react-select';
import { getOptionMap, isOptionGroups } from '../../../utils/selectOption';
import { wrapField } from '../../hooks/useForm';
import SelectInputContainer from '../SelectInput/SelectContainer';
import styles from '../SelectInput/selectInput.module.scss';
import { InputVariantEnum } from '../TopLabel';
const ALL_OPTION_LABEL = 'All';
const ALL_OPTION_VALUE = 'all';
const ALL_OPTION = { label: ALL_OPTION_LABEL, value: ALL_OPTION_VALUE };
const preChange = (allowSelectAll, options, alloptions) => {
    var _a;
    if (!allowSelectAll) {
        return options;
    }
    if (((_a = options[options.length - 1]) === null || _a === void 0 ? void 0 : _a.label) === ALL_OPTION_LABEL) {
        return isOptionGroups(alloptions) ? alloptions.map((x) => x.options || []).flat() : alloptions;
    }
    return options === null || options === void 0 ? void 0 : options.filter((option) => (option === null || option === void 0 ? void 0 : option.label) !== ALL_OPTION_LABEL);
};
const MultiSelectInput = React.forwardRef(({ id, label, options, className, value, error, isSearchable, onChange, onBlur, allowSelectAll = false, disabled, backgroundColor, clearLabel = 'Clear all', variant = InputVariantEnum.DEFAULT, }, ref) => {
    const [focused, setFocused] = useState(false);
    const updatedOptions = useMemo(() => [
        ...(allowSelectAll
            ? isOptionGroups(options)
                ? [{ label: '', options: [ALL_OPTION] }]
                : [ALL_OPTION]
            : []),
        ...options,
    ], [options, allowSelectAll]);
    const valueToOption = useMemo(() => getOptionMap(updatedOptions), [updatedOptions]);
    const allOptionsArray = isOptionGroups(options)
        ? options.map((x) => { var _a; return (_a = x.options) === null || _a === void 0 ? void 0 : _a.map((xx) => xx.value); }).flat()
        : options.map((x) => x.value);
    const valueList = value ? Array.from(value).map((item) => valueToOption.get(item)) : null;
    const componentValueList = allowSelectAll && (valueList === null || valueList === void 0 ? void 0 : valueList.length) === allOptionsArray.length ? [ALL_OPTION] : valueList;
    const selectID = `multiselect${id}`;
    const placeholder = {
        [InputVariantEnum.DEFAULT]: focused ? undefined : label,
        [InputVariantEnum.LABEL_OUTSIDE]: undefined,
    };
    return (<SelectInputContainer error={error} className={className} focused={focused} hasValue={!!value && value.size > 0} backgroundColor={backgroundColor} options={options} id={selectID} label={label} disabled={disabled} variant={variant}>
        <Select instanceId={id} name={id} inputId={selectID} onFocus={() => setFocused(true)} options={updatedOptions} placeholder={placeholder[variant]} value={componentValueList} className={classNames(styles.reactSelectContainer, !!error && styles.error, !focused && styles.unactive)} classNamePrefix='reactSelect' onChange={(ops) => {
            const newOptions = preChange(allowSelectAll, ops, options);
            return onChange(new Set(newOptions.map((option) => (option === null || option === void 0 ? void 0 : option.value) || '')));
        }} onBlur={onBlur} isMulti={true} isSearchable={isSearchable} ref={ref} isDisabled={disabled} components={{ ClearIndicator: getClearIndicator(clearLabel) }}/>
      </SelectInputContainer>);
});
const getClearIndicator = (clearLabel) => function ClearIndicator(props) {
    const _a = props.innerProps, { ref } = _a, restInnerProps = __rest(_a, ["ref"]);
    return (<div {...restInnerProps} ref={ref} className='clear'>
        {clearLabel}
      </div>);
};
MultiSelectInput.displayName = 'MultiSelectInput';
export const MultiSelectInputField = wrapField(MultiSelectInput);
export default MultiSelectInput;
